export default __webpack_public_path__ + "static/media/Plataformas.4369f4a4.jpg";